import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Paper, Typography } from '@mui/material';

const NewsCommentForm = ({
  currentUser,
  submitting,
  initialValue = '',
  initialDisplayName = null,
  onSubmit,
  onCancel,
}) => {
  const [value, setValue] = useState(initialValue);
  const isAdmin = currentUser?.role === 'ADMIN';
  // user에서 설정된 이름을 우선 사용
  const defaultLabel = currentUser?.name || currentUser?.loginId || '';
  const [displayName, setDisplayName] = useState('');

  // currentUser가 변경되거나 initialDisplayName이 변경될 때 displayName 초기화
  useEffect(() => {
    if (isAdmin) {
      // initialDisplayName이 있으면 그것을 사용 (댓글 수정 시)
      // 없으면 currentUser.name을 사용 (새 댓글 작성 시)
      if (initialDisplayName !== null && initialDisplayName !== undefined) {
        setDisplayName(initialDisplayName || '');
      } else if (currentUser?.name) {
        setDisplayName(currentUser.name);
      }
    }
  }, [currentUser, isAdmin, initialDisplayName]);

  if (!currentUser) {
    return (
      <Box
        sx={{
          mt: 1,
          borderRadius: 1,
          border: '1px solid #e0e0e0',
          px: 1.5,
          py: 1,
          bgcolor: '#f7f7f7',
          color: 'text.disabled',
          fontSize: 13,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        로그인 후 댓글을 남겨보세요.
      </Box>
    );
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) return;

    setValue('');

    if (onSubmit) {
      const nameToUse = isAdmin && displayName && displayName.trim() ? displayName.trim() : null;
      onSubmit(trimmed, nameToUse);
    }
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        mt: 1.5,
        borderRadius: 1,
        borderColor: '#d0d0d0',
      }}
    >
      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          px: 1.5,
          py: 0.6,
          gap: 0.2,
        }}
      >
        {isAdmin ? (
          <TextField
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            variant="standard"
            InputProps={{
              disableUnderline: true,
              sx: {
                fontSize: 13,
                fontWeight: 700,
                mb: 0.2,
                py: 0,
              },
            }}
            sx={{ mb: 0.2 }}
          />
        ) : (
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 700, fontSize: 13, mb: 0.2 }}
          >
            {defaultLabel}
          </Typography>
        )}

        <TextField
          multiline
          minRows={1}
          placeholder="댓글을 남겨보세요."
          value={value}
          onChange={(e) => setValue(e.target.value)}
          variant="standard"
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: 13,
              lineHeight: 1.35,
              py: 0,
            },
          }}
        />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1.5,
            fontSize: 13,
          }}
        >
          <Button
            type="button"
            size="small"
            onClick={() => {
              setValue('');
              if (onCancel) onCancel();
            }}
            sx={{
              minWidth: 'auto',
              p: 0,
              fontSize: 13,
              color: 'text.secondary',
            }}
          >
            취소
          </Button>
          <Button
            type="submit"
            size="small"
            disabled={submitting}
            sx={{
              minWidth: 'auto',
              p: 0,
              fontSize: 13,
              color: '#000',
            }}
          >
            등록
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default NewsCommentForm;

